import {
  resourceReducer,
} from 'redux-resource';
import {
  selection,
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  customListPlugin,
} from './plugins';

export default resourceReducer('programTemplates', {
  initialState: {
    ...selection.initialState,
  },
  plugins: [
    selection,
    allListPlugin,
    customListPlugin,
    includedResources,
  ],
});
